"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var range_query_request_serialiser_1 = require("./../services/timeseries/range-query-request-serialiser");
var range_query_result_serialiser_1 = require("./../services/timeseries/range-query-result-serialiser");
var time_series_append_request_serialiser_1 = require("./../services/timeseries/time-series-append-request-serialiser");
var time_series_edit_request_serialiser_1 = require("./../services/timeseries/time-series-edit-request-serialiser");
var time_series_event_metadata_serialiser_1 = require("./../services/timeseries/time-series-event-metadata-serialiser");
var time_series_timestamp_append_request_serialiser_1 = require("./../services/timeseries/time-series-timestamp-append-request-serialiser");
/**
 * Create the RANGE_QUERY service definition
 */
function rangeQueryFactory(datatypes) {
    return {
        id: 84,
        request: range_query_request_serialiser_1.RangeQueryRequestSerialiser,
        response: new range_query_result_serialiser_1.RangeQueryResultSerialiserClass(datatypes)
    };
}
exports.rangeQueryFactory = rangeQueryFactory;
exports.TIME_SERIES_APPEND = {
    id: 99,
    request: time_series_append_request_serialiser_1.TimeSeriesAppendRequestSerialiser,
    response: time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser
};
exports.TIME_SERIES_EDIT = {
    id: 100,
    request: time_series_edit_request_serialiser_1.TimeSeriesEditRequestSerialiser,
    response: time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser
};
exports.TIME_SERIES_TIMESTAMP_APPEND = {
    id: 166,
    request: time_series_timestamp_append_request_serialiser_1.TimeSeriesTimestampAppendRequestSerialiser,
    response: time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/time-series-services.js
// module id = 1638
// module chunks = 1